import type { RectVm } from "./viewModels.types";

export interface ViewportVm {
  width: number;
  height: number;
}

/** A fixed menu's position in px: `top` when it opens below its anchor, `bottom` when above. */
export interface MenuPlacementVm {
  left: number;
  top?: number;
  bottom?: number;
  /** The room the menu has on its side of the anchor; a long list scrolls inside it. */
  maxHeight: number;
}

const EDGE = 8;
const GAP = 4;
const DEFAULT_WIDTH = 240;
const DEFAULT_MIN_ROOM = 280;

export const currentViewport = (): ViewportVm => ({ width: window.innerWidth, height: window.innerHeight });

/**
 * Where a fixed menu opens: under its anchor, or above it when there is little room below and
 * more above, and never past the viewport's left or right edge. The menu's height is not
 * needed: it gets the room it has, and scrolls inside it.
 */
export const placeMenu = (
  anchor: RectVm,
  viewport: ViewportVm,
  options: { width?: number; minRoom?: number } = {},
): MenuPlacementVm => {
  const width = options.width ?? DEFAULT_WIDTH;
  const minRoom = options.minRoom ?? DEFAULT_MIN_ROOM;
  const spaceBelow = viewport.height - (anchor.top + anchor.height + GAP) - EDGE;
  const spaceAbove = anchor.top - GAP - EDGE;
  const left = Math.max(EDGE, Math.min(anchor.left, viewport.width - width - EDGE));
  if (spaceBelow < minRoom && spaceAbove > spaceBelow) {
    return { left, bottom: viewport.height - anchor.top + GAP, maxHeight: Math.max(0, spaceAbove) };
  }
  return { left, top: anchor.top + anchor.height + GAP, maxHeight: Math.max(0, spaceBelow) };
};
